// extracted by mini-css-extract-plugin
module.exports = {"wincalc-price":"price_wincalc-price__1CofK","sum":"price_sum__1YnPz"};